import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import React from "react";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import styles from "./styles";
import { withStyles } from "@material-ui/core/styles";
import CardContent from "@material-ui/core/CardContent";
import Collapse from "@material-ui/core/Collapse";
import clsx from "clsx";
import appConstants from "../../../../../../../appConstants";
import EditPickupForm from "../AddEditProForm/index";
import { Button } from "@material-ui/core";
import { isEqual } from "lodash";
import { getDataWithQueryString, getDataWithDeduplication  } from "../../../../../../../api/componentAPIs";
import { getDefaultShipmentData } from "../util";
import { withUserProfile } from "../../../../../../../userProfile/userProfileContext";
import { compose } from "recompose";
import { formatAddress } from "../../../../utils/utils";
import { ERROR_MESSAGES } from "../ProNumberValidation/utils";
import { MAX_LENGTH_CONSTRAINTS } from "../../common/constants";
import { withProValidationHOC } from "../ProNumberValidation";
import ToolTip from "../../../../../../common/StyledToolTip";
import { getCombinedExcessiveLength } from "../../utils";
import constants from "../constants";
import MESSAGES from "../../../../../../../appMessages";
import RenderCardTitle from "./renderCardTitle";

class PickupShipmentCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: props.openEditMode || false,
      initialEditInfo: props.editInfo,
      initialErrorInfo: props.errorInfo,
      openHazmatEntryForm: false,
      hazmatDetails: {},
      isAddHazmatClicked: false,
      cityList: [],
      consigneeList: [],
    };
    this.consigneeList = [];
    this.formRef = React.createRef();
  }
  componentDidMount() {
    this.terminalCode = this.props.userData.userProfile.terminal.code;
    this.timer = setTimeout(() => {
      this.formRef?.current?.scrollIntoView({
        block: "start",
        behavior: "smooth",
      });
    }, 500);
    this.handleShipperConsigneeListSuccess();
  }
  componentDidUpdate(prevProps) {
    if (this.props.isNoFreight !== prevProps.isNoFreight) {
      if (!isEqual(prevProps.editInfo, this.props.editInfo)) {
        this.setState({
          initialEditInfo: this.props.editInfo,
          initialErrorInfo: this.props.errorInfo,
        });
      }
      this.handleCloseClick();
    }
    if(!isEqual(prevProps.consigneeList, this.props.consigneeList)){
      this.handleShipperConsigneeListSuccess();
    }
  }
  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }
  handleEditClick = () => {
    if (!this.props.isNoFreight) {
      const { editProClicked } = this.props;
      this.setState({ expanded: true });
      editProClicked && editProClicked();
    }
  };
  handleCloseClick = () => {
    const { editInfo, shipmentId } = this.props;
    this.setState({
      expanded: false,
      initialEditInfo: editInfo,
      initialErrorInfo: {
        packagingItemsErrorInfo: [{ hu: null, packageCode: null }],
      },
    });
    this.props.handleCancel(shipmentId);
  };

  handleHazmatCardDelete = (index) => {
    let hazmatInfo = [...this.state.initialEditInfo.hazmatInfo];
    const filteredArray = hazmatInfo.filter((_data, i) => i !== index);
    this.setState((state) => ({
      initialEditInfo: {
        ...state.initialEditInfo,
        hazmatInfo: filteredArray,
      },
    }));
  };

  getTotalHUCount = (packagingItems) => {
    return packagingItems
      .filter((data) => data.hu)
      .reduce((acc, data) => acc + parseInt(data.hu), 0);
  };

  handleChange = (name, index) => (value) => {
    if (["hu", "packageCode"].includes(name)) {
      let packagingItems = [...this.state.initialEditInfo.packagingItems];
      let packagingItemsErrorInfo = [
        ...this.state.initialErrorInfo.packagingItemsErrorInfo,
      ];
      packagingItems[index] = { ...packagingItems[index], [name]: value };
      packagingItemsErrorInfo[index] = {
        ...packagingItemsErrorInfo[index],
        [name]: value ? this.getFieldError(name, value) : null,
      };
      this.setState((state) => ({
        initialEditInfo: {
          ...state.initialEditInfo,
          packagingItems: packagingItems,
        },
        initialErrorInfo: {
          ...state.initialErrorInfo,
          packagingItemsErrorInfo: packagingItemsErrorInfo,
          pieces: this.validatePieces(
            this.state.initialEditInfo.pieces,
            this.getTotalHUCount(packagingItems)
          ),
        },
      }));
    } else {
      let editInfo = { ...this.state.initialEditInfo, [name]: value };

      if(["excessiveLengthInches","excessiveProLength"].includes(name)){
        value = getCombinedExcessiveLength(editInfo.excessiveProLength, editInfo.excessiveLengthInches);
        if(name == "excessiveLengthInches")
          name = "excessiveProLength"
      }

      let errorInfo = {
        ...this.state.initialErrorInfo,
        [name]: this.getFieldError(name, value),
      };

      if (name === 'isExcessiveLength') {
        editInfo = { ...editInfo, excessiveProLength: null, excessiveLengthInches: null };
        errorInfo = { ...errorInfo, excessiveProLength: null, excessiveLengthInches: null };
      }

      this.setState(
        {
          initialEditInfo: editInfo,
          initialErrorInfo: errorInfo
        },
        () => {
          if (["consigneeCountry", "consigneeZip"].includes(name)) {
            this.getLocationMappingByZip();
          }
          if (name === 'consigneeZip') {
            this.updateConsigneeNameList();
          }
        }
      );
    }
  };

  checkProData = (value) => {
    this.validatePro(value).then((proError) => {
      if (!proError) {
        this.getBolData(value);
      }
    });
  };

  validatePro = (value) => {
    let proNumberError;
    const { completedProList, shipmentId, proNumberLength } = this.props;
    proNumberError = this.props.proValidation.validateProNumber({
      completedProList,
      proNumber: value,
      shipmentId,
      proNumberLength,
    });
    if (!proNumberError) {
      return getDataWithQueryString(
        "ValidatePro",
        `terminalCode=${this.terminalCode}&proId=${value}`
      )
        .then((response) => {
          proNumberError = response.data.isProExists
            ? ERROR_MESSAGES.DUPLICATE_PRO_NUMBER
            : null;
          this.updateProNumberError(proNumberError);
          return proNumberError;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    }
    this.updateProNumberError(proNumberError);
    return Promise.resolve(proNumberError);
  };

  updateProNumberError = (proNumberError) => {
    this.setState((prevState) => ({
      initialErrorInfo: {
        ...prevState.initialErrorInfo,
        proNumber: proNumberError,
      },
    }));
  };


  handleShipperConsigneeListError = () => {
    this.setState({
      consigneeList: this.props.editInfo.consigneeName
        ? [
            {
              label: this.props.editInfo.consigneeName,
              value: null,
            },
          ]
        : [],
    });
  };

  handleShipperConsigneeListSuccess = () => {
    const { consigneeList, stopData, editInfo } = this.props;
    if (!consigneeList.length) {
      this.handleShipperConsigneeListError();
      return;
    }
    const filteredList = consigneeList
      .filter((item) => item.shipperCode === stopData.accountNumber)
      .sort((consignee1, consignee2) => {
        const accountClassComparison = consignee1.accountClass.localeCompare(
          consignee2.accountClass
        );
        return accountClassComparison !== 0
          ? accountClassComparison
          : consignee1.consigneeName.localeCompare(consignee2.consigneeName);
      })
      .map(({ consigneeName, consigneeCode, consigneeZip, consigneeCity }) => ({
        label: consigneeName,
        value: consigneeCode,
        consigneeZip,
        consigneeCity
      }));
    this.consigneeList = filteredList;
    if (editInfo.consigneeName) {
      this.updateConsigneeListByName(editInfo.consigneeName);
    } else if (editInfo.consigneeZip) {
      this.updateConsigneeListByZip(editInfo.consigneeZip);
    } else {
      this.setState({ consigneeList: this.consigneeList });
    }
  };

  updateConsigneeNameList = () => {
    const { consigneeZip } = this.state.initialEditInfo;
    if (consigneeZip?.length >= constants.MIN_CONSIGNEE_ZIP) {
      this.updateConsigneeListByZip(consigneeZip);
    } else {
      this.setState({ consigneeList: this.consigneeList });
    }
  };

  updateConsigneeListByName = (name) => {
    const selectedValue = this.consigneeList.find((consignee) => consignee.label === name);
    if (!selectedValue) {
      this.setState({
        consigneeList: [{ label: name, value: null }, ...this.consigneeList]
      });
    }
  };

  updateConsigneeListByZip = (zip) => {
    const updatedList = this.consigneeList.filter(
      (consignee) => consignee.consigneeZip.toString() === zip.toString()
    );
    this.setState({ consigneeList: updatedList });
  };

  getLocationMappingByZip = () => {
    const { consigneeCountry, consigneeZip } = this.state.initialEditInfo;
    if (consigneeCountry && consigneeZip) {
      if (consigneeZip?.length >= constants.MIN_CONSIGNEE_ZIP) {
        getDataWithDeduplication(
          "GetLocationMapping",
          `terminalCode=${this.terminalCode}&country=${consigneeCountry}&zip=${consigneeZip}`,
        )
          .then((response) => {
            if (response && response.status === 200) {
              this.setState({ cityList: response.data });
            } else {
              this.setState({ cityList: [] });
            }
          })
          .catch((_error) => {
            this.setState({ cityList: [] });
          });
      } else {
        this.setState({ cityList: [] });
      }
    }
  };

  getBolData = (proNumber) => {
    let value = proNumber;
    const ProLength = MAX_LENGTH_CONSTRAINTS.PICKUP_PRO_FORM.PRO_NUMBER - 1;
    if (value.trim().length > ProLength) {
      value = value.substring(0, ProLength);
    }
    getDataWithQueryString(
      "GetBolDetails",
      `terminalCode=${this.terminalCode}&ediProNumber=${value}`
    ).then((response) => {
      if (response.data.length) {
        this.setState({
          initialEditInfo: {
            ...getDefaultShipmentData({
              getProNumber: this.props.proValidation.getProNumber,
              shipment: response.data[0],
              proNumberLength: this.props.proNumberLength,
              defaultCountry: this.props.configJSON.defaultCountry
            }),
            proNumber: proNumber,
          },
        });
      }
    });
  };

  validateHazmat = () => {
    if (this.state.initialEditInfo.isHazmat) {
      return this.state.initialEditInfo.hazmatInfo.length > 0;
    }
    return true;
  };

  validateWeight = (value) => {
    const hazmatArray = this.state.initialEditInfo.hazmatInfo;
    if (hazmatArray.length > 0) {
      const totalHazmatWeight = hazmatArray.reduce(
        (accumulator, hazmatData) => accumulator + parseInt(hazmatData.weight),
        0
      );
      return parseInt(value) > totalHazmatWeight;
    }
    return true;
  };

  validateZipCode = (value) => {
    return value?.length < constants.MIN_CONSIGNEE_ZIP ? `Min. of ${constants.MIN_CONSIGNEE_ZIP} characters` : null;
  };

  validateConsigneeName = (value) => {
    return value?.length > 30 ? "Max. of 30 characters" : null;
  };

  validateExcessiveLength = (value) => {
    if (!value) {
      return "* Pro length is required";
    }
    const { routeData } = this.props;
    const trailerLength = routeData?.trailer?.length;
    const enteredTrailerLength = value;

    const maxExcessiveLength = this.props.getExcessiveLengthMaxLimit(trailerLength);
    if (enteredTrailerLength > maxExcessiveLength) {
      return `Enter a value less than or equal to ${maxExcessiveLength} feet`;
    }
    if (enteredTrailerLength < appConstants.MIN_TRAILER_LENGTH) {
      return `Enter a value more than or equal to ${appConstants.MIN_TRAILER_LENGTH} feet`;
    }
    return null;
  };

  validatePieces = (value, totalHUCount) => {
    if (!value) {
      return "* Pieces is required";
    }
    if (parseInt(value) < totalHUCount) {
      return `Pieces should be equal or more than total handling units (${totalHUCount})`;
    }
    return null;
  };

  getTrimValue = (value) => {
    return value && value.trim();
  };
  getFieldError = (field, value) => {
    const { initialEditInfo } = this.state;
    const enableExcessiveLengthOption = this.props.configJSON?.enableExcessiveLengthOption;

    switch (field) {
      case "excessiveProLength":
        if (!enableExcessiveLengthOption) {
          return null;
        }
        return initialEditInfo.isExcessiveLength === appConstants.EXCESSIVE_SHIPMENT.YES
          ? this.validateExcessiveLength(value)
          : null;
      case "hu":
        return value ? null : "* HU is required";
      case "packageCode":
        return this.getTrimValue(value) ? null : "* Package Type is required";
      case "consigneeCountry":
        return this.getTrimValue(value) ? null : "* Country is required";
      case "consigneeZip":
        return value ? this.validateZipCode(value) : "* Zip Code is required";
      case "consigneeName":
        const trimmedValue = this.getTrimValue(value);
        if (!this.props.configJSON?.requireConsigneeDetailsForPickupCompleted && !trimmedValue) {
          return null;
        }
        return trimmedValue
          ? this.validateConsigneeName(value)
          : "* Consignee Name is required";
      case "pieces":
        return this.validatePieces(
          value,
          this.getTotalHUCount(this.state.initialEditInfo.packagingItems)
        );
      case "weight":
        const errorMessage =
          value && this.validateWeight(value)
            ? null
            : "Weight of the bill cannot be lesser than total hazmat weight";
        return value ? errorMessage : "* Weight is required";
      case "consigneeCity":
        if (!this.props.configJSON?.requireConsigneeDetailsForPickupCompleted) {
          return null;
        }
        return this.getTrimValue(value) ? null : "* Consignee City is required";
      case "isHazmat":
        return this.validateHazmat(value) ? null : "* No Hazmat Entry added";
      case "rmaxShipperCode":
        return this.props.stopData.isWarehousePickup
          ? this.validateRmaxShipperCode(value)
          : null;
      case "accessorials":
        return this.validatePickupAccessorials(value) ? null : MESSAGES.PROCESS_DELIVERY.ACCESSORIAL_REQUIRED;
      default:
        return null;
    }
  };

  validatePickupAccessorials = (value) => {    
    return this.props.configJSON.pickupAccessorialRequired ? value?.some(option => option?.isChecked) : true;
  }

  validateRmaxShipperCode = (value) => {
    return this.getTrimValue(value) ? null : "* Shipper Name is required";
  };

  validatePackages = (packages) => {
    let hasError = false;
    let hasAtleastOneValue = Boolean(
      packages?.reduce(
        (str, packageField) =>
          `${str}${packageField.hu?.toString() ?? ""}${
            packageField.packageCode ?? ""
          }`.trim(),
        ""
      )
    );
    const error = packages?.map((packageDetail, index) => {
      let packageError = {
        hu: null,
        packageCode: null,
      };
      //check for errors if there is only one entry or if only one of the field is updated
      if (
        packages.length === 1 ||
        (!hasAtleastOneValue && index === 0) ||
        Boolean(packageDetail.hu) !== Boolean(packageDetail.packageCode)
      ) {
        packageError = {
          hu: this.getFieldError("hu", packageDetail.hu),
          packageCode: this.getFieldError(
            "packageCode",
            packageDetail.packageCode
          ),
        };
      }
      hasError =
        hasError || Boolean(packageError.hu || packageError.packageCode);
      return packageError;
    });
    return hasError ? error : [];
  };

  getPackagingErrorInfo = () => {
    const { initialEditInfo } = this.state;
    const packagingItemsErrorInfo = this.validatePackages(
      initialEditInfo.packagingItems
    );
    this.setState((state) => ({
      initialErrorInfo: {
        ...state.initialErrorInfo,
        packagingItemsErrorInfo: packagingItemsErrorInfo,
      },
    }));

    return Boolean(
      packagingItemsErrorInfo?.reduce(
        (str, packageField) =>
          `${str}${packageField.hu?.toString() ?? ""}${
            packageField.packageCode ?? ""
          }`.trim(),
        ""
      )
    );
  };
  getErrorInfo = () => {
    let errorInfo = {};
    Object.keys(this.state.initialEditInfo).forEach((fieldName) => {
      errorInfo[fieldName] = this.getFieldError(
        fieldName,
        fieldName === 'excessiveProLength'
          ? getCombinedExcessiveLength(
              this.state.initialEditInfo.excessiveProLength,
              this.state.initialEditInfo.excessiveLengthInches
            )
          : this.state.initialEditInfo[fieldName]
      );
    });
    this.setState({
      initialErrorInfo: errorInfo,
    });
    return errorInfo;
  };

  getFirstFormSectionWithError = (errorInfo, packagingError) => {
    if (
      errorInfo.proNumber ||
      errorInfo.consigneeCountry ||
      errorInfo.consigneeName ||
      errorInfo.consigneeCity ||
      errorInfo.consigneeZip
    ) {
      return "proDetails";
    }
    if (packagingError || errorInfo.pieces) {
      return "packageDetails";
    }
    if (errorInfo.excessiveProLength) {
      return "shipmentDetails";
    }
    if (errorInfo.isHazmat) {
      return "hazmatDetails";
    }
  };

  handleCompleteProEntry = () => {
    const { handleCompletePro } = this.props;
    const errorInfo = this.getErrorInfo();
    const packagingDetailsErrorInfo = this.getPackagingErrorInfo();
    const error = Object.values(errorInfo).filter((value) => value).length;
    this.validatePro(this.state.initialEditInfo.proNumber).then((proError) => {
      if (!error && !packagingDetailsErrorInfo && !proError) {
        this.setState({
          expanded: false,
        });
        handleCompletePro(this.props.shipmentId, this.state.initialEditInfo);
      } else {
        const sectionWithError = this.getFirstFormSectionWithError(
          this.state.initialErrorInfo,
          packagingDetailsErrorInfo
        );
        this.scrollToErrorSection(sectionWithError);
      }
    });
  };

  addItem = () => {
    this.setState((prevState) => ({
      initialEditInfo: {
        ...prevState.initialEditInfo,
        packagingItems: [
          ...prevState.initialEditInfo.packagingItems,
          { hu: "", packageCode: "" },
        ],
      },
      initialErrorInfo: {
        ...prevState.initialErrorInfo,
        packagingItemsErrorInfo: [
          ...prevState.initialErrorInfo.packagingItemsErrorInfo,
          { hu: "", packageCode: "" },
        ],
      },
    }));
  };

  scrollToErrorSection = (sectionName) => {
    let matchedRef;
    this.formRef.current.childNodes.forEach((node) => {
      if (node.id === sectionName) {
        matchedRef = node;
        return;
      }
    });
    matchedRef?.scrollIntoView({
      block: "start",
      behavior: "smooth",
    });
  };
  addHazmatEntry = () => {
    if (Boolean(this.state.initialEditInfo.weight)) {
      this.setState({
        openHazmatEntryForm: true,
        hazmatDetails: {},
        isAddHazmatClicked: true,
      });
    } else {
      this.setState((state) => ({
        initialErrorInfo: {
          ...state.initialErrorInfo,
          weight: "* Weight is required",
        },
      }));
      this.scrollToErrorSection("packageDetails");
    }
  };

  handleHazmatEdit = () => {
    this.setState({
      isAddHazmatClicked: true,
    });
  };
  closeHazmatForm = () => {
    this.setState({
      openHazmatEntryForm: false,
      isAddHazmatClicked: false,
    });
  };
  saveHazmatEntry = (hazmatDetails, index, updateFrom) => {
    if (!updateFrom) {
      this.setState((prevState) => ({
        initialEditInfo: {
          ...prevState.initialEditInfo,
          hazmatInfo: [...prevState.initialEditInfo.hazmatInfo, hazmatDetails],
        },
        hazmatDetails: {},
        openHazmatEntryForm: false,
        isAddHazmatClicked: false,
      }));
    } else {
      let hazmatInfo = [...this.state.initialEditInfo.hazmatInfo];
      hazmatInfo[index] = { ...hazmatInfo[index], ...hazmatDetails };
      this.setState((state) => ({
        initialEditInfo: {
          ...state.initialEditInfo,
          hazmatInfo: hazmatInfo,
        },
        isAddHazmatClicked: false,
      }));
    }
  };
  showHazmatCards = () => {
    return this.state.initialEditInfo.hazmatInfo.length > 0;
  };

  getDeliveryStatusClassName = () => {
    const { classes, pickupStatus, isReadOnly } = this.props;
    if (!isReadOnly && pickupStatus === appConstants.PICKUP_STATUS.COMPLETED) {
      return classes.successStatusBG;
    }
    return classes.pendingStatusBG;
  };

  renderCardTitle = () => {
    const { editInfo, pickupIndex, classes, pickupIdToNumberMap } = this.props;
    const { pickupId, proNumber, pieces, packagingItems, weight } = editInfo ?? {};
    const hu = packagingItems?.reduce((total, item) => total + (item.hu || 0), 0);
    const pickupNumber = pickupIdToNumberMap[pickupId];
    return (
      <div className={classes.cardTitleContainer}>
        <div>
          <div className={classes.cardTitlePickupNumber}>
            PRO# <span>{proNumber}</span>
          </div>
          <div className={classes.cardProInfo}>
            PCS<span className={classes.cardProInfoValue}>{pieces || 0}</span>HU
            <span className={classes.cardProInfoValue}>{hu || 0}</span>LBS
            <span className={classes.cardProInfoValue}>{weight || 0}</span>
          </div>
        </div>
        <div className={classes.cardTitleProDetails}>
          <div className={classes.cardTitleProDetailsIndex}>
            PRO <span>{pickupIndex}</span>
          </div>
          <div>
            PICKUP # <span>{pickupNumber}</span>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const {
      classes,
      shipmentId,
      pickupStatus,
      forwardRef,
      handleChange,
      editInfo,
      errorInfo,
      limitedAccessList,
      isReadOnly,
      consigneeList,
      initialDataExists,
      ...other
    } = this.props;

    const consigneeAddress = formatAddress({
      address: editInfo?.consigneeAddress1,
      city: editInfo?.consigneeCity,
      state: editInfo?.consigneeState,
      zip: editInfo?.consigneeZip,
    });
    return (
      <div id={shipmentId} ref={forwardRef}>
        <Card className={classes.card}>
          <CardHeader
            classes={{
              title: classes.title,
              subheader: classes.subheader,
              root: classes.headerRoot,
            }}
            action={
              !this.state.expanded && (
                <ToolTip
                  title={
                    isReadOnly ? "Edit Pro (Disabled)": "Click to Edit Pro"
                  }
                >
                  <IconButton
                    aria-label="edit"
                    className={`${clsx(classes.expand, {
                      [classes.expandOpen]: this.state.expanded,
                    })} ${classes.editIcon} ${
                      this.props.isNoFreight || isReadOnly
                        ? classes.disableIcon
                        : classes.enableIcon
                    }`}
                    onClick={isReadOnly ? null : this.handleEditClick}
                    aria-expanded={this.state.expanded}
                  >
                    <EditIcon className={classes.closeIcon} />
                  </IconButton>
                </ToolTip>
              )
            }
            title={RenderCardTitle({editInfo, pickupIndex: this.props.pickupIndex, classes, pickupIdToNumberMap: this.props.pickupIdToNumberMap})}
          />
          <CardContent classes={{ root: classes.proContentContainer }}>
            <div>
              <div className={classes.shipperName}>
                {editInfo?.consigneeName}
              </div>
              <div className={classes.shipperAddress}>
                {consigneeAddress ? consigneeAddress : ""}
              </div>
            </div>
            {!this.state.expanded && (
              <div
                className={`${
                  classes.expandedCardView
                } ${this.getDeliveryStatusClassName()}`}
              >
                <span className={classes.delStatus}>
                  pickup status:{" "}
                  {pickupStatus === appConstants.PICKUP_STATUS.COMPLETED
                    ? appConstants.PICKUP_STATUS.COMPLETED
                    : appConstants.PICKUP_STATUS.WAITING}
                </span>
              </div>
            )}
          </CardContent>
          <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
            <CardContent>
              <EditPickupForm
                handleChange={this.handleChange}
                editInfo={this.state.initialEditInfo}
                errorInfo={this.state.initialErrorInfo}
                addItem={this.addItem}
                addHazmatEntry={this.addHazmatEntry}
                forwardRef={this.formRef}
                hazmatInfo={this.state.hazmatDetails}
                saveHazmatEntry={this.saveHazmatEntry}
                openHazmatEntryForm={this.state.openHazmatEntryForm}
                hazmatArray={this.state.initialEditInfo.hazmatInfo}
                handleHazmatCardDelete={this.handleHazmatCardDelete}
                showHazmatCards={this.showHazmatCards()}
                handleHazmatEdit={this.handleHazmatEdit}
                closeHazmatForm={this.closeHazmatForm}
                isAddHazmatClicked={this.state.isAddHazmatClicked}
                limitedAccessList={limitedAccessList}
                cityList={this.state.cityList}
                handleBlur={this.checkProData}                    
                consigneeList={this.state.consigneeList}
                pickupNumberOptions={this.props.pickupNumberOptions}
                initialDataExists={initialDataExists}
                {...other}
              />
              <div className={classes.cardActionRow}>
                <Button
                  autoFocus
                  color="primary"
                  variant="outlined"
                  className={classes.actionButton}
                  onClick={this.handleCloseClick}
                >
                  Cancel
                </Button>
                <Button
                  autoFocus
                  color="primary"
                  variant="contained"
                  className={classes.actionButton}
                  onClick={this.handleCompleteProEntry}
                >
                  Complete Pro Entry
                </Button>
              </div>
            </CardContent>
          </Collapse>
        </Card>
      </div>
    );
  }
}

export default compose(
  withUserProfile,
  withStyles(styles)
)(withProValidationHOC(PickupShipmentCard));
